export class GrnReturnGridDto {
    grnReturnId: number;
    grnDate: Date;
    grnReturnDate: Date;
    grnNumber: string;
    grnReturnNumber: string;
    remarks: string;
    plantId: number;
}